import { render } from "./AddAllowances.vue?vue&type=template&id=189304c6&scoped=true"
import script from "./AddAllowances.vue?vue&type=script&lang=js"
export * from "./AddAllowances.vue?vue&type=script&lang=js"

import "./../../../assets/styles/admin/form.scss?vue&type=style&index=0&id=189304c6&scoped=true&lang=scss&external"
import "./AddAllowances.vue?vue&type=style&index=1&id=189304c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189304c6"]])

export default __exports__